import { render } from "./RecuperarCompletado.vue?vue&type=template&id=0218f42c&scoped=true"
const script = {}

import "./RecuperarCompletado.vue?vue&type=style&index=0&id=0218f42c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0218f42c"]])

export default __exports__